<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-01-14 11:59 -->
<!-- Description:  -->
<template>
  <div>
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a class="nav-link" @click="tab = 'config'" :class="{'active': tab == 'config'}">Defecto</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" @click="tab = 'system'" :class="{'active': tab == 'system'}">Sistema</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" @click="tab = 'local'" :class="{'active': tab == 'local'}">Empresa</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" @click="tab = 'user'" :class="{'active': tab == 'user'}">Usuario</a>
      </li>

    </ul>

    <!-- <pre>{{ config }}</pre> -->
    <template v-if="tab == 'config'">
      <div class="list-group">
        <SettingListItem v-for="(it, ke) in config" :key="ke" :okey="ke" :item="it"
          @wantChange="handleWantChange($event)"></SettingListItem>
      </div>
    </template>
    <template v-if="tab == 'system'">
      <SettingTable :list="system" @itemDeleted="getSystemConfig()"></SettingTable>
    </template>
    <template v-if="tab == 'local'">
      <SettingTable :list="local" @itemDeleted="getLocalConfig()"></SettingTable>
    </template>
    <template v-if="tab == 'user'">
      <SettingTable :list="userConfig" @itemDeleted="getUserConfig()"></SettingTable>
    </template>

    <app-modal-basic ref="dgForm">
      <SettingForm ref="elSettingForm" @saved="$refs.dgForm.hide(); $refs.elSettingForm.reset(); reload()"></SettingForm>
    </app-modal-basic>
  </div>
</template>
<script>
import {AdminService} from "../AdminService.js";
import SettingListItem from "./SettingListItem.vue";
import SettingForm from "./SettingForm.vue";
import SettingTable from "./SettingTable.vue";

// script content
export default {
  name: "SettingsPage",
  components: {
    SettingListItem,
    SettingForm,
    SettingTable,
  },

  // directives

  props: {
    //
  },

  data: () => ({
    config: {},
    tab: 'config',
    local: [],
    userConfig: [],
    system: [],
  }),

  computed: {
    //
  },

  // watch: {},

  mounted() {
    // default config
    this.reload();
  },

  methods: {
    reload() {
      this.getSettings();
      this.getLocalConfig();
      this.getUserConfig();
      this.getSystemConfig();
    },
    async getSettings() {
      let config = await AdminService.getDefaultSettings();
      this.config = config;
    },
    async getLocalConfig() {
      let config = await AdminService.getSettings('ENTITY');
      this.local = config;
    },
    async getUserConfig() {
      let config = await AdminService.getSettings('USER');
      this.userConfig = config;
    },
    async getSystemConfig() {
      let config = await AdminService.getSettings('SYSTEM');
      this.system = config;
    },
    handleWantChange([key, item]) {
      // console.log('quiere cambiar', [key, item]);
      this.$refs.dgForm.show();
      this.$refs.elSettingForm.setValue({
        key,
        value: item,
      });
    }
    //
    //
  }
};
</script>
<style scoped></style>
